import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Item from './components/Item';
import { ITeasersContext, TeasersContext } from '../../../../teasersState/teasersContext';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { teasers } = useContext<ITeasersContext>(TeasersContext);

	const customerHeadingClasses = classNames(style.customer, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const contentTypeHeadingClasses = classNames(style.contentType, style.heading);
	const descriptionHeadingClasses = classNames(style.description, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={contentTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="contentTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={descriptionHeadingClasses}
					translationNameSpace="listing"
					translationKey="descriptionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{teasers.teasers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
